import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames/bind';

import ProductContent from 'components/shared/product-content';
import styles from './health-check.module.scss';

const cx = classNames.bind(styles);
const ASSETS_PATH = '/animations/shared/health-check';

const HealthCheck = ({ title, description, buttontext = null, buttonurl = null }) => {
  const [animationVisibilityRef, isAnimationStarted] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section className={cx('wrapper')} ref={animationVisibilityRef}>
      <div className="container">
        <div className="columns">
          <div className="column is-12-mobile  is-6-tablet">
            <ProductContent
              className={cx('content')}
              iconName="health"
              theme="secondary"
              title={title}
              description={description}
              buttonText={buttontext}
              buttonUrl={buttonurl}
            />
          </div>
        </div>

        <div className={cx('animation', { animationStarted: isAnimationStarted })} aria-hidden>
          <img className={cx('baseLayer')} src={`${ASSETS_PATH}/img_6.svg`} loading="lazy" alt="" />
          <div className={cx('doorClip')}>
            <img
              className={cx('doorLeft')}
              src={`${ASSETS_PATH}/img_4.svg`}
              loading="lazy"
              alt=""
            />
            <img
              className={cx('doorRight')}
              src={`${ASSETS_PATH}/img_5.svg`}
              loading="lazy"
              alt=""
            />
          </div>
          <div className={cx('warningCard')}>
            <img className={cx('device')} src={`${ASSETS_PATH}/img_3.svg`} loading="lazy" alt="" />
            <img
              className={cx('thermometer')}
              src={`${ASSETS_PATH}/img_2.svg`}
              loading="lazy"
              alt=""
            />
            <img
              className={cx('redCross')}
              src={`${ASSETS_PATH}/img_1.svg`}
              loading="lazy"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

HealthCheck.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  buttontext: PropTypes.string,
  buttonurl: PropTypes.string,
};

export default HealthCheck;
